import { useEffect, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import SnapChatPublicStoryPreview from './snapchat-public-story-preview.component';
import SnapChatSavedStoryPreview from './snapchat-saved-story-preview.component';
import SnapChatSpotlightPreview from './snapchat-spotlight-preview.component';

const SnapChatPreviewOrganize = ({ postType, previewData, profileId }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    if (!previewData || !profileId) return;
    let data = previewData[profileId].data;
    for (var i = 0; i < data.length; i++) {
      if (data[i].post_type === postType) {
        data[i].media_data = CommonHelper.ProcessMediaUrl(data[i].media_url);
        setData(data[i]);
      }
    }
  }, [postType, previewData, profileId]);

  return (
    <>
      {data && data?.post_type === 'PUBLIC_STORY' && <SnapChatPublicStoryPreview data={data} />}
      {data && data?.post_type === 'SPOTLIGHT' && <SnapChatSpotlightPreview data={data} />}
      {data && data?.post_type === 'SAVED_STORY' && <SnapChatSavedStoryPreview data={data} />}
    </>
  );
};

export default SnapChatPreviewOrganize;
